define(['jquery', 'responsive_common', 'swipe2'], function ($, ResponsiveCommon) {
	var ResponsiveSwipe = function () {
		var self = this;
		self.$window = $(window);
		self.width = self.$window.width();
		self.deviceSize = '';

		self.doneResizing = function() {
			self.deviceSize = self.responsiveCommon.getDeviceSize();
			if (self.deviceSize === self.responsiveCommon.small) {
				if (('ontouchstart' in window) || !!(navigator.msMaxTouchPoints)) {
					self.add();
				} else {
					self.remove();
				}
			}

			if (self.deviceSize === self.responsiveCommon.medium || self.deviceSize === self.responsiveCommon.large) {
				self.remove();
			}
		}

		self.resetAll = function () {
			var $swipes = $('.had-swipe'),
				$swipewraps = $swipes.find('.had-swipe-wrap');

			$swipewraps.addClass('swipe-wrap');
			$swipewraps.removeClass('had-swipe-wrap');

			$swipes.addClass('swipe');
			$swipes.removeClass('had-swipe');
		}

		self.add = function () {
			var self = this;

			if ($('.swipe-is-active').length === 0) {
				return;
			}

			var $swipes = $('.swipe');

			if ($swipes.length === 0) {
				$swipes = $('.had-swipe');

				if ($swipes.length > 0) {
					self.resetAll();
				} else {
					return;
				}
			}

			var index = 0;
			self.ervSwipers = [$swipes.length];
			$swipes.each(function () {


				var $swipe = $(this);
				var $bullets = $swipe.find('li.pos');

				if ($bullets.length > 1) {
					$swipe.find('.swipe-indicator').removeClass('hide');
				}

				var swiper = self.ervSwipers[index] = $swipe.Swipe({
					startSlide: 0,
					autoRestart: false,
					partial: true,
					continuous: true,
					stopPropagation: true,
					callback: function (index, element) {
						$bullets.removeClass('active');
						$bullets.eq(index).addClass('active');

						var $images = $swipe.find('.lazy');
						$images.each(function () {
							var $image = $(this);

							$image.addClass('loaded').removeClass('loading');
							$image.attr('src', $image.attr('data-src'));
						});
					},
					transitionEnd: function (index, element) { }
				}).data('Swipe');

				$bullets.on('click',
					function (e) {
						e.preventDefault();
						$bullets.removeClass('active');
						$(this).addClass('active');
						swiper.slide($(this).index());
					});

				index++;
			});
		}

		self.remove = function () {
			var self = this;

			var $swipes = $('.swipe, .had-swipe');
			$swipes.addClass('had-swipe');
			$swipes.removeClass('swipe');

			if (typeof (self.ervSwipers) !== 'undefined') {
				for (var ervSwiper of self.ervSwipers) {
					ervSwiper.kill();
				}
			}
		}

		self.init = function () {
			var self = this;
			self.responsiveCommon = new ResponsiveCommon();
			self.doneResizing();

			var width = self.$window.width(),
				deviceSize = self.responsiveCommon.getDeviceSize(),
				resizeId;

			self.deviceSize = deviceSize;

			self.$window.resize(function () {
				var newWidth = self.$window.width();

				if (width !== newWidth) {
					width = newWidth;

					clearTimeout(resizeId);
					resizeId = setTimeout(function () {
						if ($('.had-swipe').length) {
							self.remove();
						}
					}, 200);
				}
			});
		}
	}

	return ResponsiveSwipe;
});